export {};

declare global {
  interface String {
    isValidEmail(this: string): boolean;
  }
}

String.prototype.isValidEmail = function isValidEmail(this: string) {
  const emailRegex =
    /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/i;
  return emailRegex.test(this);
};
